module.exports = __webpack_public_path__ + "img/7.5c62300e.png";